
// stands for the landing page - subscription cards benefits

export const benefits={
    business: [
        {
            header:"ניהול מוצרים חכם",
            icon: "🛒",
            list:[
                "הוספה, עריכה ומחיקה של מוצרים",
                "הגדרת מחירים, תמונות, תיאורים ומלאי"
            ],
            status: "✅"
        },
        {
            header:"ניהול סניפים ומיקומים",
            icon: "📍",
            list:[
                "רשימת סניפים עם כתובת, שעות פעילות וקישור לניווט"
            ],
            status: "✅"
        },
        {
            header:"ניהול רשתות חברתיות",
            icon: "🔗",
            list:[
                "קישורים מעוצבים ל‑Instagram, Facebook ו- WhatsApp",
                // "התאמה אישית של אייקונים וצבעים"
            ],
            status: "✅"
        },
        {
            header:"התאמה אישית של האתר",
            icon: "🎨",
            list:[
                "העלאת לוגו ושינוי צבעי המותג"
            ],
            status: "✅"
        },
                {
            header:"תמיכה לכל בעיה",
            icon: "🛠",
            list:[
                "תמיכה בצ’אט או מייל"
            ],
            status: "✅"
        },
        {
            header:"ניהול עובדים ומשרות",
            icon: "👩‍💼",
            list:[
                "פרסום משרות פתוחות באתר"
            ],
            status: "✅"
        },
        {
            header:"ניהול הזמנות ולקוחות",
            icon: "📦",
            list:[
                "סקירה מלאה של הזמנות",
                "גישה לפרטי קשר של לקוחות",
                "סטטוס הזמנה: התקבלה / בטיפול / סופקה",
            ],
            status: "✅"
        },
        {
            header:"דאשבורד ניהול חכם",
            icon: "📊",
            list:[
                "נתוני תנועה ומכירות בזמן אמת"
            ],
            status: "✅"
        },
    ],
    trial:[
        {
            header:"ניהול מוצרים חכם",
            icon: "🛒",
            list:[
                "הוספה, עריכה ומחיקה של מוצרים",
                "הגדרת מחירים, תמונות, תיאורים ומלאי"
            ],
            status: "✅"
        },
        {
            header:"ניהול סניפים ומיקומים",
            icon: "📍",
            list:[
                "רשימת סניפים עם כתובת, שעות פעילות וקישור לניווט"
            ],
            status: "✅"
        },
                {
            header:"ניהול רשתות חברתיות",
            icon: "🔗",
            list:[
                "קישורים מעוצבים ל‑Instagram, Facebook ו- WhatsApp",
                // "התאמה אישית של אייקונים וצבעים"
            ],
            status: "✅"
        },
        {
            header:"התאמה אישית של האתר",
            icon: "🎨",
            list:[
                "העלאת לוגו ושינוי צבעי המותג"
            ],
            status: "✅"
        },
                {
            header:"תמיכה לכל בעיה",
            icon: "🛠",
            list:[
                "תמיכה בצ’אט או מייל"
            ],
            status: "✅"
        },
        {
            header:"ניהול עובדים ומשרות",
            icon: "👩‍💼",
            list:[
                "פרסום משרות פתוחות באתר"
            ],
            status: "❌"
        },
        {
            header:"ניהול הזמנות ולקוחות",
            icon: "📦",
            list:[
                "סקירה מלאה של הזמנות",
                "גישה לפרטי קשר של לקוחות",
                "סטטוס הזמנה: התקבלה / בטיפול / סופקה",
            ],
            status: "❌"
        },
        {
            header:"דאשבורד ניהול חכם",
            icon: "📊",
            list:[
                "נתוני תנועה ומכירות בזמן אמת"
            ],
            status: "❌"
        },
    ]
};